const comments = {
  // 定义中文
  zh: {
    comments: "留言板",
  },
  // 定义英文
  en: {
    comments: "Comment",
  },
};

export default comments;



// WEBPACK FOOTER //
// ./src/language/module/comments.js